module.exports = __webpack_public_path__ + "img/caseBanner.68593bb8.jpg";